import { WhiteLabelTheme } from '../types';

export default {
  title: 'Admin Gusto',
} as WhiteLabelTheme;
